//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import logo from "@assets/logo.png";
export default {
  data() {
    return {
      form: {
        phone: "",
        code: "",
        password: "",
      },
      imgCode: "",
      imgVerify: "",
      uuid: "",
      sms: {
        phone: "",
        type: 3,
        imgCode: "",
        uuid: "",
      },
      passw: "password",
      icon: 1,
      size: "normal",
      logoSrc: logo,
      shows: true, //获取验证码展示 false 倒计时
      count: "", //验证码倒计时
      disable: false, //控制验证码不能短期请求多次
    };
  },
  methods: {
    // 获取图形验证
    getPicCode() {
      this.$get("/sys/img/captchaImage", function (res) {
        if (res.code == 200) {
          this.imgVerify = res.data.imgVerify;
          this.uuid = res.data.uuid;
        }
      });
    },
    //发送验证码
    getverificationcode() {
      if (this.disable == true) {
        return;
      }
      if (this.form.phone == "") {
        this.$message.error("请输入手机号");
        return false;
      }
      if (!/^1[3456789]\d{9}$/.test(this.form.phone)) {
        this.$message.error("请输入正确手机号");
        return false;
      }
      if (this.imgCode == "") {
        this.$message.error("请输入图形验证");
        return false;
      }
      this.sms.phone = this.form.phone;
      this.sms.imgCode = this.imgCode;
      this.sms.uuid = this.uuid;
      this.$get(`/sys/user/sms`, this.sms, function (res) {
        if (!res) {
          this.getPicCode();
          return;
        }
        if (res.code == 200) {
          this.disable = true;
          const TIME_COUNT = 120;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.shows = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.shows = true;
                clearInterval(this.timer);
                this.disable = false;
                this.timer = null;
              }
            }, 1000);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    //密码的隐藏和显示
    showPass() {
      //点击图标是密码隐藏或显示
      if (this.passw == "text") {
        this.passw = "password";
        //更换图标
        this.icon = 1;
      } else {
        this.passw = "text";
        this.icon = 2;
      }
    },
    //密码失焦事件
    onBlur() {
      this.passw = "password";
      this.icon = 1;
    },

    login() {
      if (this.form.password != this.form.passwords) {
        this.$message.error("请确保两次输入的密码一致");
        return;
      }
      var data = {
        mobile: this.form.phone,
        smsCode: this.form.code,
        newCredential: this.form.password,
      };
      this.$put(
        "/sys/user/modify/pwd",
        data,
        function (res) {
          if (res.code == 200) {
            this.$message.success("修改成功!");
            this.$router.back(-1);
          }
        },
        true
      );
    },
  },
  mounted() {
    this.getPicCode();
  },
};
